import { ApiBase } from 'utils/api';

export default class DashboardApi {
    private base: ApiBase;

    constructor(base: ApiBase) {
        this.base = base;
    }

    get = () => {
        return this.base.axios.get('/api/dashboard');
    };
}
